function flash() {
  function messageHTML(message) {
    return (
      '<div class="alert alert-dismissible p-2" role="alert">' +
      '<button type="button" class="btn btn-close-white close float-end p-0" data-dismiss="alert" aria-label="Close">' +
      '<i class="fa fa-times" data-dismiss="alert" aria-label="Close"></i>' +
      '</button>' +
      message +
      '</div>'
    );
  }

  $('body').on('flashmessage', function (e, type, message) {
    var icon = {'notice': 'fa-check-circle', 'info': 'fa-check-circle', 'danger': 'fa-exclamation-circle'}
    var $flash = $('body > .alert-container');

    $flash[0].className = 'alert-container alert-' + type;
    var $alertNotice = $('.alert-notice, .alert-info, .alert-success, .alert-danger').not('.keep');

    $alertNotice.html(messageHTML(`<i class="fa ${icon[type]} me-2" aria-label="hidden"></i>` + message));

    var $flashKeepContainer = $('.alert-container.keep');

    if ($flashKeepContainer.length) {
      var height = $flashKeepContainer.height();
      $alertNotice.css({'margin-top': height});
    };

  });

  $('#shared-modal').on('flashmessage', function (e, type, message) {
    e.stopPropagation();

    var $flash = $('.modal-header .flash', this);

    if (!$flash.length) {
      $('.modal-header', this).prepend('<div class="flash">');
      $flash = $('.modal-header .flash', this);
    }

    $flash[0].className = 'flash alert-' + type;
    $flash.html(messageHTML(message));
  });
}

function flashCleanUp() {
  var $alertNotice = $('.alert-notice, .alert-info, .alert-success, .alert-danger').not(
    '.keep'
  );

  if ($alertNotice.length) {
    window.setTimeout(function () {
      $alertNotice.slideUp(500, function () {
        $alertNotice.empty().show();
      });
    }, 5000);
  }
}

export function flashForReact(type, message) {
  flash();
  $('body').trigger('flashmessage', [type, message]);
  flashCleanUp();
}
